module.exports = __webpack_public_path__ + "img/icon_map_nh_c.07ab0828.png";